module.exports = __webpack_public_path__ + "static/media/logo.89c38941.svg";